<template>
    <div>
      <van-nav-bar
        title="简历推荐"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft">
      </van-nav-bar>
      <div class="r-time">今天  14:09</div>
      <ul class="job-list">
        <li v-for="item in jobs" :key="item.index" @click="jobDetail">
          <div class="detail-top">
            <span>是否同意将您的简历推荐给以下职位</span>
            <div class="btn-top-cont" v-if="showBtn">
              <van-button plain type="warning" round size="small">拒绝</van-button>
              <van-button plain type="primary" round size="small">同意</van-button>
            </div>
            <div class="top-text" v-else>
              <span class="rejected" v-if="rejected">已拒绝</span>
              <span class="agreed" v-else>已同意</span>
            </div>
          </div>
          <div class="detail-info">
            <div class="info-header">
              <h3>{{item.title}} <small>急</small> </h3>
              <span>{{item.wages}}</span>
            </div>
            <ul class="conditionList">
              <li v-for="condition in item.conditionList" :key="condition.index">
                {{condition.detail}}
              </li>
            </ul>
            <ul class="feature">
              <li v-for="feature in item.featurelist" :key="feature.index">
                {{feature.detail}}
              </li>
            </ul>
          </div>
        </li>
      </ul>

    </div>
</template>

<script>
export default {
  name: 'recommendResume',
  data() {
    return {
      showBtn:true,
      rejected:false,
      jobs: [
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        }
      ]
    }
  },
  methods:{
    onClickLeft() {
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
  .r-time{
    text-align: center;
    font-size: 12px;
    color:#989DA3;
    padding:20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
  }
  .detail-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    padding-bottom: 14px;
    &>span{
      color:#989DA3;
    }
    .top-text{
      font: 12px;
      .rejected{
        color:#FF5945
      }
      .agreed{
        color:#6BCC83

      }
    }
    .btn-top-cont{
      line-height: 1;
      button{
        padding:4px 10px;
        box-shadow: none;
        margin-top: 0;
        margin-left: 16px;
        height: auto;
        .van-button__text{
          font-size: 12px;
        }
      }
    }
  }
  .job-list{
    margin-left: 0;
    margin-right: 0;
    &>li{
      padding:6px 16px;
      border-bottom: 8px solid #F7F7F7;
      &:last-child{
        border-bottom: 0;
      }
    }
  }
</style>
